<button ngfSelect
        #fileSelectButton
        [(file)]="selectedFile"
        (fileChange)="uploadFile(selectedFile)"
        type="button"
        class="image file-upload"
        data-trix-attribute="src"
        title="{{ 'bcEditor.toolbar.uploadFile' | translate }}"
        [disabled]="fileSharingService.fileMap[workItemId]">
</button>
